module.exports = __webpack_public_path__ + "static/media/appc.4e364bc3.svg";